import styles from "./Home.module.css";
import {useNavigate} from "react-router-dom"; // Import Link from react-router-dom
import {TbPhotoSearch} from "react-icons/tb";
import {LiaFileInvoiceDollarSolid} from "react-icons/lia";

const HomePage = ()=> {
    const navigate = useNavigate();
    navigate('/invoice');
}

export default HomePage;